import { Calendareventstatus } from 'data/firestore/agent/calendareventstatus/types';

const getStatusFieldName = (status: Calendareventstatus) => {
    if (!status?.removable && ['pending-approval', 'rejected'].includes(status.name)) return status.name;
    return 'accepted';
};

export default getStatusFieldName;
